(function () {
  if (window.__ljSupportGuardV3) return;
  window.__ljSupportGuardV3 = 1;

  var ROOT_ID = 'lj-contact-hub-clean';
  var CHAT_HIDE = 'data-lj-native-chat-hidden';
  var WA_HIDE = 'data-lj-native-wa-hidden';
  var OVERLAY_HIDE = 'data-lj-support-overlay-hidden';
  var SHADOW_HIDE = 'data-lj-native-toggle-hidden';
  var DOC_STYLE_ID = 'lj-native-launcher-hide-style-v3';
  var SHADOW_STYLE_ID = 'lj-native-toggle-hide-style-v3';
  var observedShadow = null;
  var shadowObserver = null;
  var shadowQueued = false;

  function installDocumentStyle() {
    if (document.getElementById(DOC_STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = DOC_STYLE_ID;
    s.textContent =
      '[' + CHAT_HIDE + '=\"1\"],[' + WA_HIDE + '=\"1\"],[' + OVERLAY_HIDE + '=\"1\"]{' +
      'opacity:0!important;visibility:hidden!important;pointer-events:none!important;' +
      '}';
    (document.head || document.documentElement).appendChild(s);
  }

  function customRoot() { return document.getElementById(ROOT_ID); }
  function insideCustom(el) {
    var root = customRoot();
    return !!(root && el && (el === root || root.contains(el)));
  }
  function rect(el) {
    try { return el.getBoundingClientRect(); }
    catch (e) { return { width:0,height:0,left:0,top:0,right:0,bottom:0 }; }
  }
  function style(el) { try { return getComputedStyle(el); } catch (e) { return null; } }
  function visible(el) {
    if (!el || !(el instanceof Element)) return false;
    var cs = style(el), r = rect(el);
    if (!cs || cs.display === 'none' || cs.visibility === 'hidden') return false;
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < innerHeight && r.left < innerWidth;
  }
  function isFixedLike(el) {
    var n = el;
    for (var i=0; n && n !== document.body && i<8; i++, n=n.parentElement) {
      var cs = style(n);
      if (cs && (cs.position === 'fixed' || cs.position === 'sticky')) return true;
    }
    return false;
  }
  function fixedOwner(el,maxW,maxH) {
    if (!el || insideCustom(el)) return null;
    var best=el,n=el;
    for (var i=0; n && n !== document.body && i<9; i++,n=n.parentElement) {
      if (insideCustom(n)) return null;
      var r=rect(n),cs=style(n);
      if (r.width>0 && r.height>0 && r.width<=maxW && r.height<=maxH) best=n;
      if (cs && cs.position === 'fixed') {
        if (r.width<=maxW && r.height<=maxH) best=n;
        break;
      }
    }
    return best;
  }
  function nearViewportEdge(el) {
    var r=rect(el);
    if (r.width<18 || r.height<16 || r.width>460 || r.height>240) return false;
    return r.bottom >= innerHeight-320 && (r.right >= innerWidth-460 || r.left <= 180);
  }
  function mark(el,attr) {
    if (!el || insideCustom(el)) return;
    var root=customRoot();
    if (root && el.contains && el.contains(root)) return;
    el.setAttribute(attr,'1');
  }
  function unmarkAll(attr) {
    document.querySelectorAll('['+attr+'=\"1\"]').forEach(function(el){el.removeAttribute(attr);});
  }

  function widget() {
    return document.querySelector('inbox-online-store-chat#ShopifyChat,inbox-online-store-chat,#ShopifyChat');
  }
  function shadowCandidates(w) {
    if (!w || !w.shadowRoot) return [];
    try {
      var sr=w.shadowRoot;
      return Array.from(sr.querySelectorAll([
        '[data-spec=\"toggle-button\"]',
        '[data-spec*=\"toggle\" i]',
        'button.chat-toggle','.chat-toggle',
        'button[aria-label*=\"chat\" i]',
        '[role=\"button\"][aria-label*=\"chat\" i]',
        'button[title*=\"chat\" i]'
      ].join(',')));
    } catch(e){ return []; }
  }
  function inboxLauncher(w) {
    var c=shadowCandidates(w);
    if (c.length) return c[0];
    try {
      if (!w || !w.shadowRoot) return null;
      var all=Array.from(w.shadowRoot.querySelectorAll('button,[role=\"button\"]'));
      return all.find(function(el){
        var t=((el.getAttribute('aria-label')||'')+' '+(el.getAttribute('title')||'')+' '+(el.textContent||'')).toLowerCase();
        var r=rect(el);
        return /chat|message|inbox/.test(t) && r.width>20 && r.height>20 && r.width<460 && r.height<220;
      }) || null;
    } catch(e){ return null; }
  }
  function inboxOpen(w) {
    if (!w) return false;
    if (String(w.getAttribute('is-open')).toLowerCase()==='true') return true;
    if (w.hasAttribute('open')) return true;
    if (String(w.getAttribute('aria-expanded')).toLowerCase()==='true') return true;
    var b=inboxLauncher(w);
    return !!(b && String(b.getAttribute('aria-expanded')).toLowerCase()==='true');
  }

  function ensureShadowStyle(sr) {
    if (!sr) return;
    var s=sr.getElementById ? sr.getElementById(SHADOW_STYLE_ID) : sr.querySelector('#'+SHADOW_STYLE_ID);
    if (!s) {
      s=document.createElement('style');
      s.id=SHADOW_STYLE_ID;
      s.textContent='['+SHADOW_HIDE+'=\"1\"]{opacity:0!important;visibility:hidden!important;pointer-events:none!important;}';
      sr.appendChild(s);
    }
  }
  function markShadowTarget(el,sr) {
    if (!el || !sr) return;
    var best=el,n=el;
    for (var i=0; n && n!==sr && i<7; i++,n=n.parentElement) {
      var r=rect(n);
      if (r.width>=18 && r.height>=16 && r.width<=460 && r.height<=220) best=n;
    }
    best.setAttribute(SHADOW_HIDE,'1');
    try {
      best.style.setProperty('opacity','0','important');
      best.style.setProperty('visibility','hidden','important');
      best.style.setProperty('pointer-events','none','important');
    } catch(e){}
  }
  function hideShadowLauncher(w) {
    if (!w || !w.shadowRoot) return;
    try {
      var sr=w.shadowRoot;
      ensureShadowStyle(sr);
      sr.querySelectorAll('['+SHADOW_HIDE+'=\"1\"]').forEach(function(el){
        var r=rect(el);
        if (r.width>500 || r.height>300) el.removeAttribute(SHADOW_HIDE);
      });
      var candidates=shadowCandidates(w);
      var fallback=inboxLauncher(w);
      if (fallback && candidates.indexOf(fallback)<0) candidates.push(fallback);
      candidates.forEach(function(el){
        var r=rect(el);
        if (r.width<=460 && r.height<=240) markShadowTarget(el,sr);
      });
    } catch(e){}
  }
  function observeShadow(w) {
    if (!w || !w.shadowRoot || w.shadowRoot===observedShadow) return;
    if (shadowObserver) shadowObserver.disconnect();
    observedShadow=w.shadowRoot;
    shadowObserver=new MutationObserver(function(){
      if (shadowQueued) return;
      shadowQueued=true;
      requestAnimationFrame(function(){
        shadowQueued=false;
        hideShadowLauncher(w);
      });
    });
    shadowObserver.observe(observedShadow,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','aria-expanded','aria-hidden','data-spec']});
    hideShadowLauncher(w);
  }

  function syncInbox() {
    var w=widget();
    observeShadow(w);
    hideShadowLauncher(w);

    if (inboxOpen(w)) {
      unmarkAll(CHAT_HIDE);
      return;
    }

    var selectors=[
      '#dummy-chat-button-iframe',
      '#shopify-chat','#ShopifyChat:not(inbox-online-store-chat)','shopify-chat','[data-shopify-chat]',
      '[id*=\"shopify-chat\" i]','[class*=\"shopify-chat\" i]',
      'iframe[id*=\"chat\" i]','iframe[title*=\"chat\" i]','iframe[src*=\"inbox\" i]','iframe[src*=\"shopify\" i][src*=\"chat\" i]',
      '[id*=\"chat-button\" i]','[class*=\"chat-button\" i]',
      '[aria-label*=\"chat with us\" i]','[title*=\"chat with us\" i]'
    ].join(',');

    document.querySelectorAll(selectors).forEach(function(el){
      if (insideCustom(el)) return;
      if (el.tagName && el.tagName.toLowerCase()==='inbox-online-store-chat') return;
      var target=fixedOwner(el,460,240)||el;
      if ((isFixedLike(target)&&nearViewportEdge(target)) || el.id==='dummy-chat-button-iframe') mark(target,CHAT_HIDE);
    });

    // Last-resort: catch a small fixed native launcher whose visible label is simply “Chat”.
    document.querySelectorAll('button,a,[role=\"button\"]').forEach(function(el){
      if (insideCustom(el) || !visible(el) || !nearViewportEdge(el) || !isFixedLike(el)) return;
      var text=((el.textContent||'')+' '+(el.getAttribute('aria-label')||'')+' '+(el.getAttribute('title')||'')).replace(/\s+/g,' ').trim().toLowerCase();
      if (text==='chat' || text==='live chat' || /^chat\b/.test(text)) mark(fixedOwner(el,460,240)||el,CHAT_HIDE);
    });
  }

  function syncWhatsApp() {
    var selectors=[
      'a[href*=\"wa.me/\"]','a[href*=\"api.whatsapp.com/\"]','a[href*=\"whatsapp.com/send\"]',
      'iframe[src*=\"whatsapp\" i]','[id*=\"whatsapp\" i]','[class*=\"whatsapp\" i]',
      '[aria-label*=\"whatsapp\" i]','[title*=\"whatsapp\" i]',
      'iframe[src*=\"carthike\" i]','[id*=\"carthike\" i]','[class*=\"carthike\" i]',
      'iframe[src*=\"chatterkart\" i]','[id*=\"chatterkart\" i]','[class*=\"chatterkart\" i]'
    ].join(',');
    document.querySelectorAll(selectors).forEach(function(el){
      if (insideCustom(el)) return;
      var target=fixedOwner(el,520,420)||el;
      if (isFixedLike(target) && (nearViewportEdge(target)||el.tagName==='IFRAME')) mark(target,WA_HIDE);
    });
  }

  var APPOINTO_SELECTORS='[id*=\"appointo\" i],[class*=\"appointo\" i],[id*=\"sidepanda\" i],[class*=\"sidepanda\" i],iframe[src*=\"appointo\" i],iframe[src*=\"sidepanda\" i],[data-app*=\"appointo\" i]';
  function modalLike(el) {
    if (!visible(el)) return false;
    var r=rect(el); if (r.width<240||r.height<240) return false;
    var cs=style(el),z=cs?parseInt(cs.zIndex||'0',10):0;
    return el.getAttribute('role')==='dialog'||el.getAttribute('aria-modal')==='true'||(cs&&cs.position==='fixed')||(!isNaN(z)&&z>=100)||el.tagName==='IFRAME';
  }
  function appointoOpen(){return Array.from(document.querySelectorAll(APPOINTO_SELECTORS)).some(modalLike);}
  function cartDrawerOpen(){return !!document.querySelector('cart-drawer.active,#CartDrawer.active,.cart-drawer.active');}
  function mobileFacetsOpen(){return innerWidth<=749 && !!document.querySelector('.mobile-facets__wrapper > details[open],.mobile-facets__disclosure[open],.mobile-facets__wrapper.menu-opening');}
  function syncOverlayGuard(){
    var blocked=appointoOpen()||cartDrawerOpen()||mobileFacetsOpen(),root=customRoot();
    if(root){if(blocked)root.setAttribute(OVERLAY_HIDE,'1');else root.removeAttribute(OVERLAY_HIDE);}
    document.querySelectorAll('['+CHAT_HIDE+'=\"1\"],['+WA_HIDE+'=\"1\"]').forEach(function(el){
      if(blocked)el.setAttribute(OVERLAY_HIDE,'1');else el.removeAttribute(OVERLAY_HIDE);
    });
  }

  var queued=false;
  function sync(){
    if(queued)return;queued=true;
    requestAnimationFrame(function(){
      queued=false;
      installDocumentStyle();
      syncInbox();
      syncWhatsApp();
      syncOverlayGuard();
    });
  }
  function boot(){
    installDocumentStyle();sync();
    [60,140,300,650,1200,2200,4000,7000,12000,18000].forEach(function(ms){setTimeout(sync,ms);});
    new MutationObserver(sync).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','aria-expanded','aria-hidden','aria-modal','open','is-open']});
    document.addEventListener('click',function(){setTimeout(sync,30);},true);
    document.addEventListener('touchend',function(){setTimeout(sync,30);},true);
    document.addEventListener('keydown',function(){setTimeout(sync,30);},true);
    addEventListener('resize',sync,{passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
